import { invoiceKeyStore } from 'Store/keyStore'
import { ICreateCustomerRequest, IProduct, ISelectedItem, ProductViewModel, InvoiceStatusType, InvoiceActionType, ICreateShopRequest, ISerialTT32, FeatureProduct  } from "Models";
import { NumberDecimalSetting } from '@/services/invoice/invoiceDetailService';

export interface IInvoiceProduct {
    products: Array<IProduct>,
    originalProducts?: Array<ProductViewModel>,
    productSelected?: ProductOptionSelected
}

export interface ProductOptionSelected {
    product: IProduct,
    index: number
}

export interface FeatureProductSelected {
    index: number,
    product: IProduct
}

export interface IInvoiceState {
    id?: string;
    invoiceNumber?: string;
    adjustId?: string;
    replaceById?: string;
    invoiceType?: InvoiceActionType;
    invoiceStatusType?: InvoiceStatusType;
    invoiceTaxNumber?: string | undefined;
    serialTT32?: ISerialTT32;
    createDate?: string;
    customerSelected?: ICreateCustomerRequest;
    shopSelected?: ICreateShopRequest;
    paymentSelected?: ISelectedItem;
    currencyTypeSelected?: ISelectedItem;
    product?: IInvoiceProduct;
    note?: string;
    numberDecimalSetting: NumberDecimalSetting;
    isUseCheckDiscount?: boolean;
    rateCheckDiscount?: number;
    rateRespectively?: number;
    vatRate?: number;
    addVatAmount?: number;
}

interface State {
    productAction: {},
    copyInvoiceToggle: boolean,
    invoice: {},
    featuredProduct?: {}
}

const getters = {
    [invoiceKeyStore.COPY_INVOICE_TOGGLE]: (state: State) => {
        return state.copyInvoiceToggle || false;
    },
    [invoiceKeyStore.INVOICE]: (state: State) => {
        return state.invoice as IInvoiceState;
    },
    [invoiceKeyStore.INVOICE_PRODUCT_OPTION_SELECTED]: (state: State) => {
        const action = state.productAction;
        state.productAction = {};
        return action;
    },
    [invoiceKeyStore.FEATURED_PRODUCT]: (state: State) => {
        const featuredProduct = state.featuredProduct;
        state.featuredProduct = {};
        return featuredProduct;
    }
}

const mutations = {
    [invoiceKeyStore.INVOICE]: (state: State, val: IInvoiceState) => {
        state.invoice = val;
    },
    [invoiceKeyStore.INVOICE_PRODUCT_OPTION_SELECTED]: (state: State, val: any) => {
        state.productAction = val ?? {};
    },
    [invoiceKeyStore.COPY_INVOICE_TOGGLE]: (state: State, val: boolean) => {
        state.copyInvoiceToggle = val as boolean;
    },
    [invoiceKeyStore.FEATURED_PRODUCT]: (state: State, val?: any) => {
        state.featuredProduct = val;
    }
}

const actions = {

}


export default {
    mutations: mutations,
    actions: actions,
    getters: getters
};